import { combineReducers } from "redux";
import jobpositionFilterReducer from "./jobpositionFilterReducer";
import jobApplicationFilterReducer from "./jobApplicationFilterReducer";
import matchAnalysisFilterReducer from "./matchAnalysisFilterReducer";
import commonFilterReducer from "./commonFilterReducer";
import jobApplicationByJPFilter from "./jobApplicationByJPFilter";
import matchAnalysisByJPFilterReducer from "./matchAnalysisByJPFilterReducer";

const filterReducer = combineReducers({
  commonFilterReducer,
  jobpositionFilterReducer,
  jobApplicationFilterReducer,
  jobApplicationByJPFilter,
  matchAnalysisFilterReducer,
  matchAnalysisByJPFilterReducer
});

export default filterReducer;
